"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPropSanitiser = void 0;
const utils_1 = require("../utils");
const Typed = __importStar(require("./sanitiserTypes"));
// ----------------------------------------------------------------------------------------------------
// --- The Sanitiser Creator ---
const createPropSanitiser = (inputProvider, callbacks) => {
    function fn(data) {
        // Bail early if no data
        if (!data)
            return null;
        return (0, utils_1.mapObject)(data, (fieldValue, fieldKey) => {
            const callback = fieldKey in callbacks && callbacks[fieldKey];
            if (callback) {
                if (callback === 'sanitise' || callback === 'sanitiseSingle') {
                    const filteredTypes = Typed.toTypedElementArray(fieldValue);
                    if (callback === 'sanitise')
                        return filteredTypes.map(fn);
                    return filteredTypes[0] ? fn(filteredTypes[0]) : null;
                }
                else {
                    return callback(fieldValue);
                }
            }
            return fieldValue;
        });
    }
    const fnOne = (inputs, typeNames) => {
        const first = (0, utils_1.firstNonNullable)(Typed.toTypedElementArray(inputs, typeNames));
        return first ? fn(first) : null;
    };
    const fnMany = (inputs, typeNames) => Typed.toTypedElementArray(inputs, typeNames).map(fn);
    fn.getRaw = inputProvider;
    fn.callbacks = callbacks;
    fn.filterElements = Typed.toTypedElementArray;
    fn.many = fnMany;
    fn.one = fnOne;
    // type Fn = typeof fn;
    fn.types = {};
    return fn;
};
exports.createPropSanitiser = createPropSanitiser;
